export interface IAgentBuild {
  id: number;
  licenseId: number;
  status: 'PENDING' | 'BUILDING' | 'READY' | 'FAILED';
  releaseVersion: string;
  error: string | null;
  createdDate: string | null;
  completedDate: string | null;
  // null on builds made before the option existed, which the worker treats as enabled.
  extensionAutoInstall: boolean | null;
}

export interface IRelease {
  version?: string;
  hasZip?: boolean;
  hasExtension?: boolean;
  hasReleaseNotes?: boolean;
  uploadedDate?: string;
}

export interface ILicense {
  id: number;
  clientId: string;
  type: string;
  maxEndpoints: number;
  startDate: string;
  endDate: string;
  modules: string;
  hwid: string | null;
  backendUrl: string | null;
  status: string;
  licenseContent: string;
  createdDate: string;
  deleted: boolean;
}

export interface ICreateLicenseDto {
  clientId: string;
  type: string;
  maxEndpoints: number;
  startDate: string;
  endDate: string;
  modules: string[];
  hwid?: string;
  backendUrl?: string;
}

export interface ILicenseFilters {
  search: string;
  type: string;
  status: string;
}

export const EMPTY_LICENSE_FILTERS: ILicenseFilters = { search: '', type: '', status: '' };

export const LICENSE_TYPES = ['TRIAL', 'SUBSCRIPTION'];

export const LICENSE_STATUSES = ['ACTIVE', 'REVOKED'];

export const LICENSE_MODULES = [
  'WATERMARK',
  'SCREENSHOT',
  'PRINT',
  'PRINT_WATERMARK',
  'USB',
  'WEB_TRAFFIC',
  'EMAIL',
  'CLIPBOARD',
  'ACTIVITY_TRACKING',
];
